// Vehicle management functionality

// Vehicle edit modal
$(function () {
    $(".modal-edit-vehicle").on("click", function (e) {
        e.preventDefault();
        const id = $(this).data("vehicle");

        $.ajax({
            url: "/clientes/buscar-dados-veiculo",
            method: "POST",
            data: { id: id },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            success: function (response) {
                $("#modalEditVehicle").remove();
                const csrfToken = document
                    .querySelector('meta[name="csrf-token"]')
                    .getAttribute("content");
                const editUrl = `/veiculos/${response.data.id}`;

                const modal = createVehicleEditModal(
                    response.data,
                    editUrl,
                    csrfToken
                );
                $("body").append(modal);

                // Apply plate search functionality after modal is created
                setTimeout(() => {
                    setupModalPlateSearch();
                    // Reinicializar máscaras para elementos criados dinamicamente
                    if (window.masksValidator) {
                        window.masksValidator.setupPlateMasks();
                    }
                    // Garantir que o data-format também funcione
                    const plateInput = document.getElementById("inputPlate");
                    if (plateInput && plateInput.hasAttribute("data-format")) {
                        // Trigger o evento para inicializar a máscara data-format
                        plateInput.dispatchEvent(new Event("input"));
                    }
                }, 100);

                const modalInstance = new bootstrap.Modal(
                    document.getElementById("modalEditVehicle")
                );
                modalInstance.show();
            },
            error: function (xhr, status, error) {},
        });
    });
});

function createVehicleEditModal(vehicleData, editUrl, csrfToken) {
    const colorOptions = [
        "AMARELO",
        "AZUL",
        "BEGE",
        "BRANCO",
        "CINZA",
        "DOURADO",
        "LARANJA",
        "MARROM",
        "PRATA",
        "PRETO",
        "ROSA",
        "ROXO",
        "VERDE",
        "VERMELHO",
        "FANTASIA",
    ];

    const colorOptionsHtml = colorOptions
        .map(
            (color) =>
                `<option value="${color}" ${
                    vehicleData.cor === color ? "selected" : ""
                }>${color}</option>`
        )
        .join("");

    return `
        <div class="modal fade" id="modalEditVehicle" tabindex="-1" aria-labelledby="modalEditVehicleLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="modalEditVehicleLabel">Editar veículo</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <i class="sg sg-x"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form class="row g-4" id="editVehicle" method="post" action="${editUrl}">
                            <input type="hidden" name="_token" value="${csrfToken}">
                            <input type="hidden" name="_method" value="PUT">
                            <input type="hidden" name="redirect" value="client">
                            <input type="hidden" name="idVeiculo" value="${vehicleData.id}">
                            <input type="hidden" name="idCliente" value="${vehicleData.proprietario}">
                            <input type="hidden" name="oficinaVinculada" value="${vehicleData.oficina_vinculada}">

                            <div class="col-6 col-md-3">
                                <label for="inputPlate" class="form-label">Placa</label>
                                <input type="text" class="form-control  is-valid" id="inputPlate" name="placaVeiculo"
                                       data-format="XXX-9999" data-alt-format="XXX-9X99"
                                       placeholder="Ex: AAA 0000" value="${vehicleData.placa}">
                            </div>

                            <div class="col-6 col-md-3">
                                <label for="inputBrand" class="form-label">Marca</label>
                                <input type="text" id="inputBrand" class="form-control"
                                       name="marcaVeiculo" value="${vehicleData.marca}">
                            </div>

                            <div class="col-md-6">
                                <label for="inputModel" class="form-label">Modelo</label>
                                <input type="text" id="inputModel" class="form-control"
                                       name="modeloVeiculo" value="${vehicleData.modelo}">
                            </div>

                            <div class="col-6 col-md-2">
                                <label for="inputYearOfManufacture" class="form-label">Ano</label>
                                <input type="text" id="inputYearOfManufacture" class="form-control"
                                       name="anoVeiculo" value="${vehicleData.ano}">
                            </div>

                            <div class="col-6 col-md-2">
                                <label for="inputYearModel" class="form-label">Ano modelo</label>
                                <input type="text" id="inputYearModel" class="form-control"
                                       name="anoModeloVeiculo" value="${vehicleData.ano_modelo}">
                            </div>

                            <div class="col-6 col-md-3">
                                <label for="inputTypeOfFuel" class="form-label">Combustível</label>
                                <input type="text" id="inputTypeOfFuel" class="form-control"
                                       name="combustivelVeiculo" value="${vehicleData.combustivel}">
                            </div>

                            <div class="col-6 col-md-5">
                                <label for="inputChassis" class="form-label">Chassi</label>
                                <input type="text" class="form-control" id="inputChassis"
                                       name="chassiVeiculo" value="${vehicleData.chassi}">
                            </div>

                            <div class="col-6 col-md-3">
                                <label for="inputCarColor" class="form-label">Cor</label>
                                <select id="inputCarColor" class="form-select" name="corVeiculo">
                                    <option>Selecione</option>
                                    ${colorOptionsHtml}
                                </select>
                            </div>

                            <div class="col-12">
                                <button type="submit" class="btn btn-primary" data-loading-text="Salvando...">
                                    Salvar alterações
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    `;
}

// Vehicle brand and model functionality
$(document).ready(function () {
    // Verificar se estamos na página de edição de veículos
    const isVehicleEditPage =
        window.location.pathname.includes("/veiculos/") &&
        window.location.pathname.includes("/edit");

    // Apenas aplicar funcionalidade em páginas que não sejam de edição de veículos
    if (
        !$("body").hasClass("orders-edit") &&
        !$("body").hasClass("orders-create") &&
        !isVehicleEditPage
    ) {
        if ($("#inputBrand option").length <= 2) {
            obterMarcas();
        }

        $(".vehicle-type-button").on("click", function () {
            obterMarcas();
        });

        $("#inputBrand").on("change", function () {
            const codMarca = $(this).val();

            // Verificar se codMarca é válido antes de fazer a requisição
            if (!codMarca || codMarca === "") {
                // Limpar o select de modelos se não há marca selecionada
                const modelSelect = document.getElementById("inputModel");
                if (modelSelect) {
                    modelSelect.innerHTML =
                        '<option value="">Selecione o modelo</option>';
                }
                return;
            }

            fetch(`/veiculos/obter-modelos/${codMarca}`)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(
                            `HTTP error! status: ${response.status}`
                        );
                    }
                    return response.json();
                })
                .then((data) => {
                    const modelSelect = document.getElementById("inputModel");
                    modelSelect.innerHTML =
                        '<option value="">Selecione o modelo</option>';

                    if (data && Array.isArray(data)) {
                        data.forEach((modelo) => {
                            const displayText = modelo.refFipe
                                ? `${modelo.nomeModelo} (${modelo.refFipe})`
                                : modelo.nomeModelo;
                            const option = new Option(
                                displayText,
                                modelo.codModelo
                            );
                            if (modelo.refFipe) {
                                option.setAttribute(
                                    "data-reference",
                                    modelo.refFipe
                                );
                            }
                            modelSelect.appendChild(option);
                        });
                    }
                })
                .catch((error) => {});
        });

        // Setup plate search functionality for modal - removed from here
        // Will be called after modal creation
    }

    // Prevent vehicle type button events on edit pages
    if (isVehicleEditPage) {
        $(".vehicle-type-button").off("click");
    }
});

function setupModalPlateSearch() {
    const plateInput = $("#modalEditVehicle #inputPlate");
    let searchTimeout;

    if (plateInput.length === 0) {
        return;
    }

    // Remove any existing event listeners
    plateInput.off("input.plateSearch blur.plateSearch");

    // Add input event listener for plate search
    plateInput.on("input.plateSearch", function () {
        const rawValue = $(this).val();
        const plate = rawValue.replace(/[^A-Za-z0-9]/g, "").toUpperCase();

        // Clear previous timeout
        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }

        // Check if plate is complete (7 characters for Brazilian plates)
        if (plate.length === 7) {
            // Add debounce to avoid excessive API calls
            searchTimeout = setTimeout(() => {
                $(this).addClass("loading");
                searchVehicleByPlateModal(plate);
            }, 500); // Wait 500ms after user stops typing
        } else {
            // Clear fields if plate is incomplete
            clearModalVehicleFields();
        }
    });
}

function searchVehicleByPlateModal(plate) {
    $.ajax({
        url: "/veiculos/buscar-dados",
        method: "POST",
        data: {
            placa: plate,
            _token: $('meta[name="csrf-token"]').attr("content"),
        },
        success: function (response) {
            $("#modalEditVehicle #inputPlate").removeClass("loading");

            if (response.success && response.data) {
                let vehicleData;

                // Parse data if it's a string
                if (typeof response.data === "string") {
                    try {
                        vehicleData = JSON.parse(response.data);
                    } catch (e) {
                        return;
                    }
                } else {
                    vehicleData = response.data;
                }

                // Fill modal form with vehicle data
                fillModalVehicleData(vehicleData);
            } else {
                // Clear fields if no data found
                clearModalVehicleFields();
            }
        },
        error: function (xhr, status, error) {
            $("#modalEditVehicle #inputPlate").removeClass("loading");
            clearModalVehicleFields();
        },
    });
}

function fillModalVehicleData(data) {
    try {
        // Map API fields to modal form fields
        const fieldMappings = {
            marca: "#inputBrand",
            modelo: "#inputModel",
            anoFabricacao: "#inputYearOfManufacture",
            anoModelo: "#inputYearModel",
            combustivel: "#inputTypeOfFuel",
            chassi: "#inputChassis",
            cor: "#inputCarColor",
            renavam: "#inputRenavam",
        };

        // Fill basic fields
        Object.keys(fieldMappings).forEach((apiField) => {
            const formField = fieldMappings[apiField];
            const value = data[apiField];

            if (value && $(formField).length) {
                if ($(formField).is("select")) {
                    // For select fields, try to find matching option
                    const option = $(formField)
                        .find(`option:contains("${value}")`)
                        .first();
                    if (option.length) {
                        $(formField).val(option.val()).trigger("change");
                    } else {
                        // If no exact match, add new option for API data
                        $(formField).append(
                            `<option value="${value}" selected>${value}</option>`
                        );
                    }
                } else {
                    $(formField).val(value);
                }
            }
        });

        // Handle brand selection specially for modal
        if (data.marca) {
            handleModalBrandSelection(data.marca, data.modelo);
        }
    } catch (error) {
        //nsole.error("Error filling modal vehicle data:", error);
        // Erro ao preencher dados
    }
}

function handleModalBrandSelection(brandName, modelName) {
    // First, try to find the brand in the current options
    const brandSelect = $("#inputBrand");
    let brandOption = brandSelect
        .find(`option:contains("${brandName}")`)
        .first();

    if (brandOption.length) {
        // Brand found, select it
        brandSelect.val(brandOption.val()).trigger("change");

        // Wait for models to load, then select model
        setTimeout(() => {
            if (modelName) {
                const modelSelect = $("#inputModel");
                const modelOption = modelSelect
                    .find(`option:contains("${modelName}")`)
                    .first();
                if (modelOption.length) {
                    modelSelect.val(modelOption.val());
                } else {
                    // Add model option if not found
                    modelSelect.append(
                        `<option value="${modelName}" selected>${modelName}</option>`
                    );
                }
            }
        }, 1000);
    } else {
        // Brand not found, add it as a new option
        brandSelect.append(
            `<option value="${brandName}" selected>${brandName}</option>`
        );
        if (modelName) {
            $("#inputModel").append(
                `<option value="${modelName}" selected>${modelName}</option>`
            );
        }
    }
}

function clearModalVehicleFields() {
    // Clear all vehicle data fields except plate in modal
    const fieldsToKeep = ["#inputPlate"];
    const allFields = [
        "#inputBrand",
        "#inputModel",
        "#inputYearOfManufacture",
        "#inputYearModel",
        "#inputTypeOfFuel",
        "#inputChassis",
        "#inputCarColor",
        "#inputRenavam",
        "#inputEngineNumber",
        "#inputHP",
        "#inputMileage",
    ];

    allFields.forEach((field) => {
        if (!fieldsToKeep.includes(field)) {
            if ($(field).is("select")) {
                $(field).val("").trigger("change");
            } else {
                $(field).val("");
            }
        }
    });
}

function showModalMessage(message, type = "info") {
    // Função mantida mas sem toast - apenas para compatibilidade
    // Pode ser usada para logs ou outras funcionalidades futuras
}

export function obterMarcas() {
    // Verificar se estamos na página de edição de veículos
    const isVehicleEditPage =
        window.location.pathname.includes("/veiculos/") &&
        window.location.pathname.includes("/edit");

    // Se estivermos na página de edição, não executar a função
    if (isVehicleEditPage) {
        return;
    }

    const brandSelect = document.getElementById("inputBrand");
    if (brandSelect) {
        const tipo = $(".vehicle-type-button.active").data("tipo");
        $("#tipoVeiculo").val(tipo);

        fetch(`/veiculos/obter-marcas/${tipo}`)
            .then((response) => response.json())
            .then((data) => {
                $("#inputBrand option").remove();
                brandSelect.appendChild(new Option("Selecione a marca", ""));
                data.forEach((brand) => {
                    const option = document.createElement("option");
                    option.value = brand.codMarca;
                    option.textContent = brand.nomeMarca;
                    brandSelect.appendChild(option);
                });
            });
    }
}
